export const token = 'token'
export const access_token = 'access_token'
export const appLanguage = 'app_language'